export const About = () => {
  return (
    <div
      className="bg-cover bg-center bg-no-repeat flex flex-col justify-center items-center"
      style={{ backgroundImage: "url('/imgs/about/top.png')", height: "500px" }}
    >
      <div className="font-[Alibaba PuHuiTi 3.0,Alibaba PuHuiTi 30] font-bold text-[50px] text-[#333333] leading-[100px]">
        光年无界科技
      </div>
      <div className="font-[Alibaba PuHuiTi 3.0,Alibaba PuHuiTi 30] font-light text-[29px] text-[#333333] leading-[100px]">
        助力企业光速出海，成就全球无界时代
      </div>
    </div>
  );
};
